import React, {useContext, useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import __ from "lodash";

import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import BookingQueueList from "./components/BookingQueueList";
import BookingQueueForm from "./components/BookingQueueForm";
import BookingQueueTrips from "./components/BookingQueueTrips";
import BookingQueueStyles from "./styles/BookingQueueStyles";
import BookingQueueSelector from "./components/BookingQueueSelector";
import {getSearchValues} from "./BookingHelperFunctions";
import SystemContext from "../../SystemContext";
import {getDefaultValuesWithoutAlert} from "../../functions/TemplateHelperFunctions";
// import {useHistory} from "react-router-dom";

const AccessControl = require ("../../AccessControl");

function BookingList(props) {
  const SystemData = useContext(SystemContext);
  const localValues = SystemData.localValues;
  const classes = makeStyles(BookingQueueStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage BOOKINGS"]);

  const [state, setState] = useState({
    selectedRecord: null
  });
  const [defaults, setDefaults] = useState(null);
  // const history = useHistory();
  const handleClose = event => {
    // history.push(menuItems[0].path);
    SystemData.goHome();
  };

  const getDefaults = async () => {
    const defaults = await getDefaultValuesWithoutAlert(SystemData, "booking", "defaults");
    if (!defaults)
      return null;
    return defaults;
  }

  getDefaults()
    .then((bookingDefaults) => {
      if (!defaults)
        setDefaults(bookingDefaults);
    })
    .catch((error) => {
      handleClose();
      SystemData.alert("Error", error);
    });

  let theme = useTheme();
  const values = {
    xs: 0,
    sm: 600,
    lsm: 720,
    md: 960,
    mlg: 1120,
    lg: 1280,
    lgr: 1750,
    xl: 1920,
    xxl: 2400
  };

  // const searchExtraKeys = [airlineCode, flightNo, tripNumber, fromDate, toDate, destinationAirportCode, clientUuid, accountManagerId, awbPrefix, awbSerial, allotment, bookingStatus]
  const searchExtraKeys = getSearchValues(localValues ? localValues.getValue( "FlightBooking") : []);

  theme.breakpoints = {...theme.breakpoints,
    keys: ['xs', 'sm', 'lsm', 'md', 'mlg', 'lg', 'lgr', 'xl', 'xxl'],
    up: key => `@media (min-width:${values[key]}px)`,
  };

  const changeSelectedRecord = (selectedRecord) => {
    setState({...state, selectedRecord});
  }

  return (isAuthenticated &&
    <div
      className="BookingQueue"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="bookingsheet"
        pageName="Flight Bookings"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div className={classes.rooted} style={{width: "100%", height: 70, display: "block"}}>
        <div className={classes.rooted} style={{height: "100%", display: "block", marginLeft: 40, marginRight: 40, backgroundColor: "#ffffff"}}>
          <BookingQueueSelector searchCriteria={localValues ? localValues.getValue( "FlightBooking") : undefined}/>
        </div>
      </div>
      <div style={{height: 10}}></div>

      <div
        className={classes.rooted}
        style={{ marginLeft: 20, marginRight: 20, minHeight: `calc(100vh - ${(99+2+10+57+4+16+68)}px)`, height: `calc(100vh - ${(99+2+10+57+4+16+68)}px)` }}
      >
        <div style={{display: "flex", width: "100%", position: "relative"}}>
          <div style={{display: "inline-flex", position: "relative", width: `calc(100vw - 495px)`, maxWidth: `calc(100vw - 495px)`}}>{/* minWidth: listWidth, */}
            <BookingQueueList searchBookings searchExtraKeys={searchExtraKeys} onChangeSelected={changeSelectedRecord} canEdit={canEdit} classes={classes} theme={theme} height={99+2+10+57+4+16+68} defaults={defaults}/>
          </div>
          <div style={{display: "inline-flex", width: 400, MinWidth: 400, maxWidth: 400, height: "100%", marginLeft:20, backgroundColor: "#ffffff"}}>
            <BookingQueueForm canEdit={false} classes={classes} height={99+2+10+57+4+16+68}/>
          </div>
        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default BookingList;
